export class Market {
  id!: number;
  icon!: string;
  name!: string;
  order!: number;
}
